import React,{useState} from "react";

//import scss
import "./Mid-Section.scss";

//import icons
import { CiSearch } from "react-icons/ci";
import PropertiesCard from "./PropertiesCard";

const MidSectionPropertiesMobile = () => {
  const [isSqueezed, setIsSqueezed] = useState(false);

   const [searchTerm, setSearchTerm] = useState("");
  
  return (
    <div className="properties-page-mobile">
      <div className="top-section-properties">
      <div className="search-container">
        <div className="search-bar">
          <div className="search-icon">
            <CiSearch />
          </div>
          <input
            type="text"
            placeholder="Search Properties"
            value={searchTerm}
            className="search-input"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      </div>
      
      <div className="properties-container">
        <PropertiesCard
          key="1"
          name="Example One"
          isSqueezed={isSqueezed}
          setIsSqueezed={setIsSqueezed}
        />
      </div>
    </div>
  );
};

export default MidSectionPropertiesMobile;
